<template>
  <v-container fluid class="news-page px-0">
    <section v-if="isUSNewsPage" class="coming-soon-section">
      <div class="coming-soon-inner">
        <span class="accent-square"></span>
        <p class="coming-soon-label">USA News</p>
        <h1 class="coming-soon-title">Coming Soon</h1>
        <p class="coming-soon-copy">
          OH.YES news and updates for the USA will be available here soon.
        </p>
      </div>
    </section>
    <template v-else>
      <section class="hero">
        <div class="hero-inner">
          <h1 class="hero-title">
            <span class="accent-square"></span>
            Latest News
          </h1>
          <p class="hero-sub">
            What's new at OH.YES — announcements, updates, and stories.
          </p>
        </div>
      </section>
      <v-container class="py-6">
        <div class="logo-strip-wrapper">
          <div class="logo-strip">
            <div class="logo-track">
              <div
                class="logo-item"
                v-for="(logo, index) in newsLogos"
                :key="index"
              >
                <img :src="logo" alt="news logo" />
              </div>
              <!-- Duplicate for seamless loop -->
              <div
                class="logo-item"
                v-for="(logo, index) in newsLogos"
                :key="'dup-' + index"
              >
                <img :src="logo" alt="news logo" />
              </div>
            </div>
          </div>
        </div>
      </v-container>

      <!-- Featured Slider -->
      <v-container class="py-8">
        <v-carousel
          cycle
          height="500"
          hide-delimiter-background
          show-arrows-on-hover
          class="featured-carousel"
        >
          <v-carousel-item v-for="(item, i) in featuredItems" :key="i">
            <v-card class="featured-card" height="100%">
              <v-img
                :src="item.src"
                height="100%"
                class="featured-img"
                contain
              />
            </v-card>
          </v-carousel-item>
        </v-carousel>
      </v-container>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "NewsPage",
  data() {
    return {
      newsLogos: [
        require("@/assets/icons/newslogo1.jpeg"),
        require("@/assets/icons/newslogo2.jpg"),
        require("@/assets/icons/newslogo3.jpeg"),
        require("@/assets/icons/newslogo4.jpg"),
        require("@/assets/icons/newslogo5.jpeg"),
        require("@/assets/icons/newslogo6.png"),
        require("@/assets/icons/newslogo7.png"),
        require("@/assets/icons/newslogo8.jpeg"),
        require("@/assets/icons/newslogo9.png"),
      ],
      featuredItems: [
        { src: require("@/assets/images/news1.jpeg") },
        { src: require("@/assets/images/news2.jpeg") },
        { src: require("@/assets/images/news3.jpeg") },
        { src: require("@/assets/images/news4.jpeg") },
        { src: require("@/assets/images/news5.jpeg") },
        { src: require("@/assets/images/news6.jpeg") },
        { src: require("@/assets/images/news7.jpeg") },
        { src: require("@/assets/images/news8.jpeg") },
        { src: require("@/assets/images/news9.jpeg") },
        { src: require("@/assets/images/news10.jpeg") },
      ],
    };
  },
  computed: {
    isUSNewsPage() {
      return (
        this.$route.meta?.location === "us" ||
        this.$route.path?.startsWith("/us")
      );
    },
  },
};
</script>

<style scoped>
.news-page {
  --accent: #f46523;
  --accent-600: #e65511;
  --muted: rgba(0, 0, 0, 0.6);
}

.hero {
  position: relative;
  padding: 22px 16px 48px;
  background: white;
}

.hero-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.hero-title {
  font-weight: 800;
  font-size: 48px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: var(--accent-600);
}

.hero-sub {
  margin-top: 12px;
  font-size: 18px;
  color: var(--muted);
  max-width: 700px;
}

.accent-square {
  width: 18px;
  height: 18px;
  background: linear-gradient(135deg, var(--accent), #ff8c42);
  border-radius: 4px;
  box-shadow: 0 6px 18px rgba(244, 101, 35, 0.18);
}

.coming-soon-section {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background: #fff;
}

.coming-soon-inner {
  width: 100%;
  max-width: 720px;
  text-align: center;
}

.coming-soon-inner .accent-square {
  display: inline-block;
  margin-bottom: 22px;
}

.coming-soon-label {
  margin: 0 0 8px;
  color: var(--accent-600);
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.coming-soon-title {
  margin: 0;
  color: #111827;
  font-size: 48px;
  font-weight: 800;
  line-height: 1.1;
}

.coming-soon-copy {
  margin: 18px auto 0;
  max-width: 520px;
  color: var(--muted);
  font-size: 18px;
  line-height: 1.6;
}

.logo-strip-wrapper {
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(244, 101, 35, 0.08),
    rgba(244, 101, 35, 0.03)
  );
  padding: 22px 0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(15, 15, 15, 0.06);
}

.logo-strip {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.logo-track {
  display: flex;
  gap: 36px;
  align-items: center;
  animation: scroll 30s linear infinite;
  width: fit-content;
  padding: 8px 24px;
}

.logo-item {
  flex-shrink: 0;
  transition:
    transform 220ms ease,
    box-shadow 220ms ease;
}

.logo-item:hover {
  transform: translateY(-6px) scale(1.02);
}

.logo-item img {
  height: 56px;
  width: auto;
  object-fit: contain;
  background: white;
  padding: 10px 22px;
  border-radius: 32px;
  display: block;
  box-shadow: 0 6px 18px rgba(10, 10, 10, 0.08);
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.logo-track:hover {
  animation-play-state: paused;
}

.featured-carousel {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(12, 12, 12, 0.08);
}

.featured-card {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
}

.featured-img {
  object-fit: cover !important;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.12));
  min-height: 320px;
}

.featured-caption {
  position: absolute;
  left: 24px;
  bottom: 24px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0.7)
  );
  padding: 16px 20px;
  border-radius: 12px;
  max-width: 70%;
  box-shadow: 0 10px 30px rgba(10, 10, 10, 0.08);
}

.featured-caption h3 {
  margin: 0 0 6px 0;
  font-size: 20px;
  color: #111;
}

.featured-caption p {
  margin: 0;
  font-size: 14px;
  color: rgba(17, 17, 17, 0.7);
}

.featured-carousel .v-carousel__controls__item {
  background: rgba(255, 255, 255, 0.9) !important;
  border: 2px solid rgba(0, 0, 0, 0.06) !important;
}

.featured-carousel .v-carousel__controls .v-btn--icon {
  color: var(--accent) !important;
}

@media (max-width: 900px) {
  .hero-title {
    font-size: 36px;
  }

  .logo-track {
    gap: 20px;
  }

  .logo-item img {
    height: 48px;
    padding: 8px 16px;
  }

  .featured-caption {
    left: 16px;
    bottom: 16px;
    max-width: 85%;
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 28px;
  }

  .logo-track {
    gap: 16px;
  }

  .logo-item img {
    height: 38px;
    padding: 8px 14px;
  }

  .featured-caption h3 {
    font-size: 16px;
  }

  .featured-caption p {
    font-size: 12px;
  }
}
</style>
